/**
 * @desc 保存
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.Response;
export function request(body: defs.device.FirmwareRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/firmware/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
